// extracted by mini-css-extract-plugin
module.exports = {"container":"patient-summary-container-module__container___3M0cP"};